import Cookie from 'js-cookie';
import request from '../libs/request/index.js';
function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  if (match) {
    return match[2];
  }
  return "";
}
async function autoLogin() {
  // 判断当前为非登录状态
  //   if (!(getCookie('hik_connect_pro_userlogin') && localStorage.getItem('hik_connect_pro_data'))) {
  // 未登录，但是打开的页面是登录后的页面。记录一下链接，登录后恢复到这个页面
  // if (isAutoJumpPage()) {
  //   sessionStorage.setItem('jump-after-login', window.location.href);
  // }
  const autoLoginCookie = getCookie('portalAutoLoginId');
  try {
    // 存在自动登录cookie
    if (autoLoginCookie
        && (!window.location.href.includes('?hpcAfterLogin=true')
            && !window.location.href.includes('?hpcAutoLogin=true')
            && !window.location.href.includes('ticketJump')
            && !window.location.href.includes('authorizationCode')
            && !window.location.href.includes('thirdJump')
            && !window.location.href.includes('invitedRegisterAfter')
            && !window.location.href.includes('invitedRegister')
            && !window.location.href.includes('check'))) {
      //cookie校验接口
      const authorizeRes = await request.post('/hpp/ccfauth/public/authorize', {
        productId: 1,
        businessId: 0,
        clientSource: 0
      }, { hasErrorHandle: false }).catch(() => null);
      if (authorizeRes?.[0]?.loginType === 1 || authorizeRes?.[0]?.loginType === 2) {
        if (authorizeRes?.[0]?.loginType === 2) { // hpc 自动登录
          localStorage.setItem('autoLoginTicket', authorizeRes[0].authTicket);
          window.location.href = `${window.location.origin}?hpcAutoLogin=true`;
        } else if (authorizeRes?.[0]?.loginType === 1) { // SSO 自动登录
          window.location.href = `${window.location.origin}/?ticket=${authorizeRes[0]?.authTicket}&autoLogin=true#/ticketJump/login`;
        }
      }
    } else if ((window.location.href.includes('authorizationCode')
            || window.location.href.includes('invitedRegisterAfter')
            || window.location.href.includes('invitedRegister'))) {
      // 部分情况下，删除上次的自动登录标记
      Cookie.remove('portalId');
      Cookie.remove('portalAutoLoginId');
    }
  } catch (error) {
    console.log('自动登录失败');
  }
  //   }
}
autoLogin();
